<lot-unit-table [heading]="'Locations' | tenantWords" [keyHeader]="'Location' | tenantWords" [rows]="this.rows"></lot-unit-table>
